import { IbanElement } from "@stripe/react-stripe-js";
import { ButtonDS, Modal, Tabs } from "get-life-storybook-ts";
import ModalPolicyController, {
  PaymentMethodT,
} from "./ModalPolicy.controller";
import CardSetupForm from "../../../PaymentGateway/components/CardSetupForm/CardSetupForm.component";
import CreaditCard from "get-life-storybook-ts/lib/components/Icons/CreditCard";
import ContinueArrow from "get-life-storybook-ts/lib/components/Icons/ContinueArrow";

const ModalPolicy = ({
  availablePaymentMethod,
  clientSecret,
  fetchGetDataCard,
  nodeElementModal,
  userData,
}: any) => {
  const {
    cardOnly,
    cardOnlyText,
    handleClickSubmit,
    handleStripeStatus,
    IBAN_ELEMENT_OPTIONS,
    setPaymentMethod,
    stripeInputStatus,
    translate,
  } = ModalPolicyController({
    nodeElementModal,
    clientSecret,
    fetchGetDataCard,
    userData,
  });

  const allNavTabs: any = [
    {
      id: "card",
      title: translate("dashboard.tab.card"),
      activeTab: "card",
      icon: <CreaditCard />,
      disabled: !availablePaymentMethod?.creditCard,
    },
    {
      id: "sepa_debit",
      title: translate("dashboard.tab.sepa"),
      icon: <ContinueArrow />,
      disabled: !availablePaymentMethod?.sepa,
    },
  ];

  const allTabsContent: any = [
    {
      id: "card",
      children: (

        <CardSetupForm
          handleStripeStatus={handleStripeStatus}
          stripeInputStatus={stripeInputStatus}
          translate={translate}
        />

      ),
    },
    {
      id: "sepa_debit",
      children: (

        <IbanElement options={IBAN_ELEMENT_OPTIONS} />

      ),
    },
  ];

  // «Solo tarjeta»: fuera la pestaña SEPA, no basta con deshabilitarla.
  const offered = (tab: { id: string }) => !cardOnly || "card" === tab.id;
  const listNavTabs = allNavTabs.filter(offered);
  const listTabsContent = allTabsContent.filter(offered);

  return (
    <Modal
      ref={nodeElementModal}
      classNameContent="dashboard__modal"
      ModalTitle={
        <p className="dashboard__modal--title">
          {translate("dashboard.modal.modify")}
        </p>
      }
      ModalBody={
        <>
          {cardOnly && (
            <p className="BodyM text-[#424242] mb-[16px]" role="status">
              {cardOnlyText}
            </p>
          )}
          <Tabs
            // Remontar al cambiar la marca devuelve las pestañas a «tarjeta».
            key={cardOnly ? "card-only" : "all-methods"}
            listNavTabs={listNavTabs}
            listTabsContent={listTabsContent}
            onChange={(id) => setPaymentMethod(id as PaymentMethodT)}
          />
        </>
      }
      ModalActions={
        <ButtonDS
          label={translate("dashboard.policy.editBtn")}
          onClick={() => handleClickSubmit()}
        />
      }
    />
  );
};

export default ModalPolicy;
